module.exports = __webpack_public_path__ + "static/media/duetigli-512.c623aa18.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duetigli-512.png
// module id = 781
// module chunks = 0